import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { BadgeCheck } from "lucide-react";
import { METRIC_DEFS } from "@/lib/metrics";
import { formatMetric, formatPeriodLabel, formatDate } from "@/lib/format";

export const UpdateReader = ({ update, company, badge }) => {
  const metrics = update?.metrics_snapshot || {};
  const present = METRIC_DEFS.filter((d) => metrics[d.key] !== null && metrics[d.key] !== undefined && metrics[d.key] !== "");
  return (
    <div data-testid="update-reader" className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_300px]">
      <article className="min-w-0">
        <div className="mb-1 text-xs font-medium uppercase tracking-wide text-primary">
          {company?.name} · {formatPeriodLabel(update?.period)}
        </div>
        <h1 className="h-display text-2xl font-semibold text-foreground md:text-3xl">{update?.title}</h1>
        <div className="mt-1 text-xs text-muted-foreground">
          {update?.published_at ? `Published ${formatDate(update.published_at)}` : "Draft preview"}
        </div>
        {update?.tldr && (
          <div className="mt-4 rounded-xl border-l-4 border-primary bg-secondary/60 px-4 py-3 text-sm text-foreground">
            <span className="font-semibold">TL;DR: </span>{update.tldr}
          </div>
        )}
        <div className="prose-update mt-4 max-w-none text-sm md:text-base" data-testid="update-reader-body">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{update?.body_markdown || ""}</ReactMarkdown>
        </div>
        {badge?.streak_months > 0 && (
          <a href={`/verify/${badge.badge_token}`} target="_blank" rel="noreferrer"
          className="mt-6 inline-flex items-center gap-1.5 rounded-full border border-brand/30 bg-brand/[0.07] px-3 py-1.5 text-xs font-semibold text-brand-ink transition-colors hover:bg-brand/[0.14]"
            data-testid="update-badge-stamp">
            <BadgeCheck className="h-3.5 w-3.5" />
            {badge.streak_months}-month update streak · verified on TenX
          </a>
        )}
      </article>

      <aside className="lg:sticky lg:top-20 lg:self-start">
        <div data-testid="update-reader-metric-rail" className="rounded-xl border bg-card p-4 shadow-[var(--shadow-sm)]">
          <div className="mb-3 text-xs font-semibold uppercase tracking-wide text-muted-foreground">Key Metrics</div>
          {present.length === 0 ? (
            <div className="text-sm text-muted-foreground">No metrics attached.</div>
          ) : (
            <div className="space-y-2.5">
              {present.map((d) => (
                <div key={d.key} className="flex items-center justify-between">
                  <span className="text-sm text-muted-foreground">{d.label}</span>
                  <span className="h-display text-sm font-semibold tabular-nums text-foreground">{formatMetric(d.type, metrics[d.key])}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </aside>
    </div>
  );
};
